<template>
  <div class="modal-cadastro-usuario">
    <v-dialog :value="show" @input="fechar" max-width="800">
      <v-card>
        <v-card-title>{{ titleComputed }}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <input type="hidden" v-model="usuario.id" />
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="usuario.name"
                  label="Nome"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="usuario.email"
                  label="E-mail"
                  :rules="emailRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  type="password"
                  v-model="usuario.password"
                  label="Senha"
                  :rules="usuario.id ? [] : passwordRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-select
                  outlined
                  v-model="usuario.id_perfil"
                  label="Perfil"
                  :rules="requiredRules"
                  required
                  :items="perfis"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="usuario.cpf"
                  label="CPF"
                  required
                  :rules="requiredRules"
                />
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-switch v-model="isAgente" label="Agente"></v-switch>
              </v-col>
              <template v-if="isAgente">
                <v-col cols="12" md="12" sm="12">
                  <h3>Dados do agente</h3>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-text-field
                    outlined
                    v-model="usuario.cpf"
                    label="CPF"
                    :rules="requiredRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-text-field
                    outlined
                    v-model="usuario.matricula"
                    label="Matrícula"
                    :rules="requiredRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-select
                    :items="unidadesAutuadoras"
                    outlined
                    v-model="usuario.unidade_autuadora"
                    label="Unidade Autuadora"
                    :rules="requiredRules"
                    required
                  ></v-select>
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" outlined @click="fechar">cancelar</v-btn>
          <v-btn color="primary" @click="salvar(usuario)">salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ModalCadastroUsuario",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editar: {
      type: Object,
      default: () => ({})
    },
    perfis: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      unidadesAutuadoras: [
        'Agentes de Trânsito da AMC',
        'Agentes de Trânsito da GMF',
        'Agentes de Trânsito da PRE'
      ],
      usuario: {},
      agente: {},
      isAgente: false,
      valid: true,
      situacao: [{ text: "Ativo", value: 1 }, { text: "Inativo", value: 0 }],
      requiredRules: [v => !!v || "Este Campo é Obrigatório"],
      passwordRules: [
        v => !!v || "Este Campo é obrigatório",
        v => (v && v.length > 5) || "A senha precisa ter 6 ou mais caracteres"
      ],
      emailRules: [
        v => !!v || "E-mail é obrigatório",
        v => /.+@.+\..+/.test(v) || "E-mail inválido"
      ]
    };
  },
  methods: {
    fechar() {
      this.$emit("fechar");
      this.$refs.form.resetValidation();
    },
    salvar(usuario) {
      if (!this.$refs.form.validate()) return;
      this.$emit("submit", usuario);
    }
  },
  computed: {
    titleComputed() {
      return this.editar.id ? "Editar Usuário" : "Cadastro Usuário";
    }
  },
  watch: {
    editar: function(newUsuario) {
      this.usuario = { ...newUsuario, ...newUsuario.agente };
      this.isAgente = !!newUsuario.agente;
    }
  }
};
</script>
